import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8">
      <div className="wrap flex flex-col md:flex-row md:items-center justify-between gap-4">
        <p className="t-display text-2xl">
          Karan<span className="text-[var(--signal)]">.</span>
        </p>
        <p className="text-sm text-[var(--muted)]">© {currentYear} Karan Dixit</p>
        <div className="flex gap-5 text-sm">
          <a href="https://github.com/dixitk941" target="_blank" rel="noopener noreferrer" className="text-[var(--muted)] no-underline hover:text-[var(--ink)]">GitHub</a>
          <a href="https://www.linkedin.com/in/karan-dixit21" target="_blank" rel="noopener noreferrer" className="text-[var(--muted)] no-underline hover:text-[var(--ink)]">LinkedIn</a>
          <a href="mailto:dixitk941@gmail.com" className="text-[var(--muted)] no-underline hover:text-[var(--ink)]">Email</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
